import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { ProductViewResponse } from "../interface/view-product.interface";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ModalViewProductService {
  private apiUrl = `${environment.apiUrl}/view-product`
  constructor(
    private http: HttpClient,


  ) { }


  /**
   * Obtiene los detalles de un producto por su ID, incluyendo variaciones y complementos
   * @param id ID del producto
   * @returns Observable con la respuesta de la API
   */
  getProductById(id: number): Observable<ProductViewResponse> {
    return this.http.get<ProductViewResponse>(`${this.apiUrl}/${id}`);
  }
}


